import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/fields';

Component('tr-todo-page-fields', {
  mixins: [eventListenerMixin],

  properties: {
    editUrl: String,

    collapsed: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.initCollapse();
    this.listenTo(this, 'tr-todo-custom-field:change', this.handleCustomFieldChange.bind(this));
  },

  handleCustomFieldChange(event) {
    event.stopPropagation();

    const fieldKey = event.target.key;
    let data = { [fieldKey]: event.detail };

    const isMultipleSelect = !!event.target.querySelector('tr-multiple-select-field');
    if (isMultipleSelect && event.detail.length === 0) {
      data = { [`${fieldKey}[]`]: '' };
    }

    this.update(data)
      .then((todo) => {
        this.namespacedTrigger('fieldChange', {
          detail: { todo, fieldKey },
          bubbles: true,
        });
      });
  },

  initCollapse() {
    if (!this.collapsed) return;

    const link = this.querySelector('.link-expend');
    this.listenTo(link, 'click', () => {
      this.collapsed = false;
      link.remove();
    });
  },

  update(data) {
    if (this.editUrl) {
      return $.ajax({
        url: this.editUrl,
        type: 'patch',
        dataType: 'json',
        data: {
          todos_management: data,
        },
      });
    }

    return new Promise(resolve => resolve(data));
  },

  disconnected() {
    this.stopListening();
  },
});
